module.exports = __webpack_public_path__ + "img/hero.ec5b134d.webp";